import { render } from "./NewsEventDetailPage.vue?vue&type=template&id=38de600e"
import script from "./NewsEventDetailPage.vue?vue&type=script&lang=js"
export * from "./NewsEventDetailPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__